import { render, staticRenderFns } from "./TgFreezeDialog.vue?vue&type=template&id=1fd47a19"
import script from "./TgFreezeDialog.vue?vue&type=script&lang=js"
export * from "./TgFreezeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports